import * as Yup from "yup";

import getDateString from "../../../utils/getDateString";
import {
  dateValidation,
  isFirstDateAfterSecondDate,
} from "../../../utils/yupValidation";
import { ModifyCallFormValues } from "./ModifyCallModal";

const modifyCallFormSchema: Yup.SchemaOf<ModifyCallFormValues> =
  Yup.object().shape({
    issueDate: Yup.string().default(""),
    dueDate: dateValidation()
      .required("Required")
      .test(
        "date compare",
        "Must be greater than or equal to issue date",
        (value, context) => {
          return isFirstDateAfterSecondDate(
            value,
            getDateString(context.parent.issueDate)
          );
        }
      ),
    callAmountDisplay: Yup.string()
      .max(16, "Maximum 16 characters")
      .required("Required")
      .default(""),
    callAmountRaw: Yup.number().min(0.01, "Minimum amount: 0.01"),
  });

export default modifyCallFormSchema;
